import { Route, Routes } from 'react-router-dom'

import {
  ConfirmationCellphone,
  Plate,
  RegisterRntrc,
  RegisterCellphone,
  RegisterFullName,
  RegisterPassword,
  RegisterSuccess,
  SelfieDescription,
  VehicleType,
  SelfieTake,
  SelfieConfirmation,
  VehicleBody,
  VehicleTracking,
  RegisterByYourCellphone,
} from '~containers'
import { ProgressBarWrapper } from '~components'

function Register() {
  return (
    <Routes>
      <Route index element={<RegisterCellphone />} />
      <Route path="sucesso" element={<RegisterSuccess />} />
      <Route path="confirmar-celular" element={<ConfirmationCellphone />} />
      <Route path="cadastre-pelo-celular" element={<RegisterByYourCellphone />} />
      <Route element={<ProgressBarWrapper />}>
        <Route path="rastreador-veiculo" element={<VehicleTracking />} />
        <Route path="nome-completo" element={<RegisterFullName />} />
        <Route path="placa" element={<Plate />} />
        <Route path="rntrc" element={<RegisterRntrc />} />
        <Route path="tipo-veiculo" element={<VehicleType />} />
        <Route path="tipo-carroceria" element={<VehicleBody />} />
        <Route path="selfie">
          <Route index element={<SelfieDescription />} />
          <Route path="tirar" element={<SelfieTake />} />
          <Route path="confirmacao" element={<SelfieConfirmation />} />
        </Route>
        <Route path="senha" element={<RegisterPassword />} />
      </Route>
    </Routes>
  )
}

export default Register
